import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { VARIABLE_SELECTORS } from './promise-ai.constants';

export function validateDateVariables(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value || '';
    if (!value.includes(VARIABLE_SELECTORS.MIN_DATE) || !value.includes(VARIABLE_SELECTORS.MAX_DATE)) {
      return {
        missingVariables: `Must include both ${VARIABLE_SELECTORS.MIN_DATE} and ${VARIABLE_SELECTORS.MAX_DATE} variables`,
      };
    }
    return null;
  };
}
